<template>
  <label class="flex items-center">
    <input
      type="radio"
      class="form-radio h-5 w-5"
      :name="name"
      :value="value"
      @input="onSelect"
      :checked="checked"
      :disabled="disabled"
    />
    <div class="ms-2">
      <slot>
        <span>{{ label }}</span>
      </slot>
    </div>
  </label>
</template>

<script>
export default {
  props: {
    // This is the name of the group of radio buttons
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      required: true,
    },
    // Whether the radio button is selected at start
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSelect() {
      this.$emit("input", this.value);
    },
  },
};
</script>
